import React from 'react';
import {connect} from 'react-redux';
import AccessToServices from './AccessToServices';

const AccessToServicesBlock = ({data, context, accessToServices, family, currentSubscriber}) => {
  let accessToSerivcesComponent = <div></div>;
  switch (family) {
    case 'C':
      accessToSerivcesComponent = (
        <AccessToServices data={data} context={context} accessToServices={accessToServices} currentSubscriber={currentSubscriber} />
      );
      break;
    default:
      break;
  }
  return accessToSerivcesComponent;
};

const mapStateToProps = (state) => {
  return {
    accessToServices: state.cellcomTransactionSummary.transactionData.accessToServices,
    family: state.cellcomTransactionSummary.transactionData.generalDetails.family,
    currentSubscriber: state.cellcomTransactionSummary.callular,
  };
};

export default connect(mapStateToProps, null)(AccessToServicesBlock);
